import ajax from '../http/ajax'

export const getMoreSstoreGoodsDetail = param => {
    return ajax.get('getMoreSstoreGoodsDetail', param)
}
/**
 *
 * param {sstore_id: '', // 门店id
    goods_type: '', // 商品类型（proprietary:自营，agent：代理）
    goods_id: '', // 商品规格id
    spu_id: '', // 商品id} param
 */
export const getMoreSstoreGoodsDetailSpecList = param => {
    return ajax.get('getMoreSstoreGoodsDetailSpecList', param)
}
